var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoAdv",on:{"click":function($event){return _vm.jump(_vm.item.adv)}}},[_c('ImgDecypt',{attrs:{"src":_vm.item.adv&&_vm.item.adv.pictureUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }